/**************************************************
 * Nombre:       Bolsillo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Ahorro from "../../Tarjetas_Especiales/Tarjeta_Ahorro";
import Tarjeta_Deposito from "../../Tarjetas_Especiales/Tarjeta_Deposito";
import React, {useEffect, useState} from "react";
import Tarjeta_Alerta from "../../Tarjetas_Especiales/Tarjeta_Alerta";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Bolsillo = ({item, recargar}) => {
    const {sCell} = useResponsive()
    const [deposito, setDeposito] = useState('')
    const [antesDe, setAntesDe] = useState('')
    const [openDeposito, setOpenDeposito] = useState(false)
    const [openAlerta, setOpenAlerta] = useState(false)


    useEffect(() => {
        setDeposito('')
        //Saber si hay deposito Nuevo
        let w = [where('idBolsillo', '==', item.id), where('estado', '==', 'Nuevo'), where('tipo', '==', 'Deposito')]
        obtenerColWheres({col: 'movimientos', wheres: w}).then((dox) => {
            if (dox.res && dox.data[0]) {
                setDeposito(dox.data[0])
            }
        })
    }, [item]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={3}
        >

            <Grid container size={{xs: 12, sm: 6, md: 4}} sx={{justifyContent: 'flex-start', zIndex: 3}}>
                <Tarjeta_Ahorro item={item} recargar={recargar}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 6, md: 4}}
                  sx={{justifyContent: 'flex-start', zIndex: 2, mt: openDeposito ? 0 : sCell ? -22.5 : 0}}>
                <Tarjeta_Deposito item={item} recargar={recargar} setAntesDe={setAntesDe} openDeposito={openDeposito}
                                  setOpenDeposito={setOpenDeposito}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 6, md: 4}}
                  sx={{justifyContent: 'flex-start', zIndex: 1, mt: openAlerta ? 0 : sCell ? -23.5 : 0}}>
                {deposito &&
                    <Tarjeta_Alerta item={deposito} recargar={recargar} antesDe={antesDe} openAlerta={openAlerta}
                                    setOpenAlerta={setOpenAlerta}/>
                }
            </Grid>

        </Grid>
    )

}
export default Bolsillo